var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQRcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_158_2894)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 160,
    height: 160,
    rx: 4,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4878 30.7966H34.6504V44.8069H48.4878V30.7966Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.674 16.7864V23.7915H110.755V30.7967H117.674V58.8173H124.593V65.8224H117.674V72.8276H124.593H131.511V58.8173H152.267V65.8224H159.186V58.8173V16.7864H117.674ZM152.267 51.8121H124.593V23.7915H152.267V51.8121Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.355 30.7966H131.518V44.8069H145.355V30.7966Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4878 128.869H34.6504V142.879H48.4878V128.869Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.59 114.858H117.671V121.864H124.59V114.858Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9919 149.884H83.0732V156.889H89.9919V149.884Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9187 121.864H90V128.869H96.9187V121.864Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9187 135.874H90V142.879H96.9187V135.874Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.184 100.848H152.266V107.853H159.184V100.848Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7336 100.848H20.8149V107.853H27.7336V100.848Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7336 65.8225H20.8149V72.8277H27.7336V65.8225Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9106 23.7915V30.7967H83.0732V37.8018H103.829V30.7967V23.7915H96.9106Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.257 72.8276V79.8328H138.42V86.8379H117.664V79.8328H110.745V86.8379H96.9081V93.8431H117.664V100.848H103.827H96.9081V93.8431H89.9894V100.848H83.0707V93.8431H76.1521V100.848H69.2334V107.853H83.0707V114.859H89.9894V107.853H103.827V114.859H96.9081V121.864H103.827V135.874H110.745V142.879H117.664V135.874H138.42V121.864H145.339V114.859H138.42V100.848H124.583V93.8431H138.42V100.848H145.339V93.8431H152.257V86.8379H159.176V79.8328V72.8276H152.257ZM131.501 107.853V128.869H110.745V107.853H131.501Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.757 58.8174H103.839V65.8225H96.9199V72.8277V79.8328H103.839V72.8277H110.757V65.8225H117.676V58.8174H110.757Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.757 149.884H96.9199V156.889H110.757V149.884Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0866 23.7915H76.168V30.7967H83.0866V23.7915Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.437 72.8276H131.518V79.8328H138.437V72.8276Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.349 65.8225H138.431V72.8277H145.349V65.8225Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.401 100.848H48.4824V107.853H55.401V100.848Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.327 149.884V121.864H69.2456V114.859V107.854H62.327V114.859H41.571V107.854H34.6523H27.7336V114.859H20.8149V156.89H62.327H76.1643V149.884H62.327ZM55.4083 149.884H27.7336V121.864H55.4083V149.884Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2517 58.8174H62.333V65.8225H69.2517V58.8174Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2456 16.7864H62.327H20.8149V58.8173H27.7336V65.8224H34.6523V58.8173H41.571V65.8224H48.4896V58.8173H62.327V44.807H69.2456V37.8018H62.327V23.7915H69.2456H76.1643V16.7864H69.2456ZM55.4083 51.8121H27.7336V23.7915H55.4083V51.8121Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.75 37.8018H103.832V44.8069H110.75V37.8018Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9187 16.7864H90V23.7915H96.9187V16.7864Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M103.839 58.8174V51.8123H96.9203V44.8071H90.0016V51.8123H76.1643V44.8071H69.2456V51.8123V58.8174H76.1643V72.8278H55.4083V65.8226H48.4896V72.8278H27.7336V79.8329H41.571V86.8381H20.8149V93.8433H41.571V100.848H48.4896V93.8433H55.4083V100.848H62.327V93.8433H76.1643V86.8381H69.2456V79.8329H76.1643H83.083V86.8381H90.0016H96.9203V79.8329H90.0016V72.8278H83.083V58.8174H103.839ZM62.327 86.8381H48.4896V79.8329H62.327V86.8381Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0708 128.869V121.864V114.859H76.1521V121.864H69.2334V128.869H76.1521V135.874H69.2334V142.879H83.0708V135.874H89.9895V128.869H83.0708Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M145.346 142.879V135.874H138.427V142.879H117.671V149.884H131.508V156.889H138.427V149.884H152.264V156.889H159.183V149.884V142.879H145.346Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M152.272 114.858V121.864H145.354V128.869H159.191V121.864V114.858H152.272Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_158_2894",
    x: 0,
    y: 0,
    width: 180,
    height: 180,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_2894"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_158_2894",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQRcode);
export default __webpack_public_path__ + "static/media/QRcode.de7b80146d27ef0fc92a1b4cb76e5353.svg";
export { ForwardRef as ReactComponent };